module.exports = __webpack_public_path__ + "img/1013_cover.18f81587.jpg";